// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2bCty","title":"Card_title__Ipc2d","genre":"Card_genre__1U_Nz"};